import React from 'react';
import '../../styles/SuppressorModal.css';

const SuppressorModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  if (!isOpen) return null;

  return (
    <div className="suppressor-modal-overlay" onClick={onClose}>
      <div className="suppressor-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="suppressor-modal-header">
          <h2>Add Suppressor</h2>
        </div>
        <div className="suppressor-modal-body">
          <p>
            The <strong>{itemName}</strong> is available with a suppressor for an additional $20.
          </p>
          <p>Would you like to add a suppressor to your order?</p>
        </div>
        <div className="suppressor-modal-footer">
          <button className="suppressor-btn suppressor-btn-cancel" onClick={onClose}>
            No Thanks
          </button>
          <button className="suppressor-btn suppressor-btn-confirm" onClick={onConfirm}>
            Add Suppressor (+$20)
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuppressorModal;